/**
 * External dependencies
 */

 import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'

import {
	createButtonAttributeNames,
	createResponsiveAttributeNames,
	createTypographyAttributeNames,
	getBootstrapClasses, 
	range
} from '~cartzillagb/util'

import {
	HeadingButtonsControl,
	PanelAdvancedSettings,
	ButtonControlsHelper,
	ButtonEditHelper,
	ImageUploadPlaceholder,
	ColumnControl,
	URLInputControl
} from '~cartzillagb/components'

import { i18n } from 'cartzillagb'
import classnames from 'classnames'



/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl, RangeControl, BaseControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.youtube-feed-block.edit.inspector.style.before', 'cartzillagb/youtube-feed-block', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		enableSubscriberImages,
		enableSubscriberCount,
		enableButton,
		enableBadge,
		enableVideoTitle,
		// Title.
		showTitle = true,
		titleTag = '',

		// Button.
		showHeaderButton = false,
		lgColumns,
		limit
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>

				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Display Subsciber Picture', i18n ) }
					checked={ enableSubscriberImages }
					onChange={ enableSubscriberImages => setAttributes( { enableSubscriberImages } ) }
				/>

				<ToggleControl
					label={ __( 'Display Subsciber Count', i18n ) }
					checked={ enableSubscriberCount }
					onChange={ enableSubscriberCount => setAttributes( { enableSubscriberCount } ) }
				/>

				<ToggleControl
					label={ __( 'Display Subscibe Button', i18n ) }
					checked={ enableButton }
					onChange={ enableButton => setAttributes( { enableButton } ) }
				/>

				<ToggleControl
					label={ __( 'Show Timer on Video Image', i18n ) }
					checked={ enableBadge }
					onChange={ enableBadge => setAttributes( { enableBadge } ) }
				/>

				<ToggleControl
					label={ __( 'Display Video Title', i18n ) }
					checked={ enableVideoTitle }
					onChange={ enableVideoTitle => setAttributes( { enableVideoTitle } ) }
				/>

				<RangeControl
					label={ __( 'Limit' ) }
					value={ limit }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.youtube-feed-block.edit.inspector.max.limit', 4 ) }
				/>
				
				<ColumnControl
					label={ __("Column Width", i18n ) }
					lgColumns={lgColumns }
					smMin={ 1 }
					smMax={ 12 }
					onChangelg={ value => setAttributes( { lgColumns: value } ) }
				/>
				
			</PanelBody>
			<PanelBody title={ __( 'Button Settings', i18n ) }initialOpen={ false } >
	            <ButtonControlsHelper
	                attrNameTemplate="button1%s"
	                setAttributes={ setAttributes }
	                blockAttributes={ props.attributes }
	            />
	        </PanelBody>

	        <PanelAdvancedSettings
				title={ __( 'Title', i18n ) }
				id="title"
				checked={ showTitle }
				onChange={ showTitle => setAttributes( { showTitle } ) }
				toggleOnSetAttributes={ [
					...createTypographyAttributeNames( 'title%s' ),
					'titleTag',
				] }
				toggleAttributeName="showTitle"
			>
				<HeadingButtonsControl
					value={ titleTag || 'h3' }
					onChange={ titleTag => setAttributes( { titleTag } ) }
				/>
			</PanelAdvancedSettings>
			<PanelAdvancedSettings
				title={ __( 'Header Button', i18n ) }
				id="header-button"
				checked={ showHeaderButton }
				onChange={ showHeaderButton => setAttributes( { showHeaderButton } ) }
				toggleOnSetAttributes={ [
					...createButtonAttributeNames( 'headerButton%s' ),
					...createResponsiveAttributeNames( 'headerButton%sAlign' ),
				] }
				toggleAttributeName="showHeaderButton"
			>
				<ButtonControlsHelper
					attrNameTemplate="headerButton%s"
					setAttributes={ setAttributes }
					blockAttributes={ props.attributes }
				/>
			</PanelAdvancedSettings>

			<PanelBody title={ __( 'Video Link Settings', i18n ) } initialOpen={ false }>
				{ range( 1, limit + 1 ).map( i => {

					const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'

					return (
						<BaseControl label={ __( `Video Link #${ i } Settings`, i18n ) } id={ "url" }>
							<URLInputControl
								key={ i }
								value={ link }
								onChange={ link => setAttributes( { [ `link${ i }` ]: link } ) }
							/>
						</BaseControl>
						
					)
				} ) }
				
			</PanelBody>
        </Fragment>
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		enableContainer,
		enableSubscriberImages,
		enableSubscriberCount,
		enableButton,
		enableBadge,
		enableVideoTitle,

		// Title.
		showTitle = true,
		title = '',
		titleTag = 'h2',

		// Button.
		showHeaderButton = false,
		lgColumns,
		limit,
		mediaURL,
		subscriberCount,
		text,
		mediaURL1
	} = attributes


	const mainClasses = classnames( [
		className,
		'pb-5 mb-md-3',
		'youtub-feed-block'
	], applyFilters( 'cartzillagb.youtube-feed-block.main-block.classes', {
		'container': enableContainer,
	}, props ) )

	const titleComp = showTitle && (
		<RichText
			tagName={ titleTag || 'h2' }
			value={ title }
			className={ classnames( [
				'czgb-youtube-feed__title',
				showHeaderButton ? 'h4 mb-3' : 'h4 mb-3 text-center',
			] ) }
			placeholder={ __( 'Title for This Block', i18n ) }
			onChange={ title => setAttributes( { title } ) }
			keepPlaceholderOnFocus
		/>
	)

	const headerButtonComp = showHeaderButton && (
		<ButtonEditHelper
			attrNameTemplate="headerButton%s"
			setAttributes={ setAttributes }
			blockAttributes={ props.attributes }
		/>
	)

	const buttonComp = enableButton && (
		<ButtonEditHelper
			attrNameTemplate="button1%s"
            setAttributes={ setAttributes }
            blockAttributes={ props.attributes }
		/>
	)
	const headerComp = showTitle && showHeaderButton ? (
		<div className="czgb-youtube-feed__header d-flex flex-wrap justify-content-between align-items-center pt-3 pb-2" >
			{ titleComp }
			<div className="mb-3" >
				{ headerButtonComp }
			</div>
		</div>
	) : ( showTitle ? (
		titleComp
	) : ( showHeaderButton ? (
		<div className="czgb-youtube-feed__header d-flex flex-wrap justify-content-between align-items-center pt-3 pb-2" >
			{ headerButtonComp }
		</div>
	) : '' ) )


	const content = range( 1, ( limit ) + 1 ).map( i => {
		const imageURL = attributes[ `imageURL${ i }` ]
		const badge = attributes[ `badge${ i }` ]
		const videoTitle = attributes[ `videoTitle${ i }` ]
		let defaultTimer = ''
		let defaultVideoTitle = ''
		const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'

		if ( (i % 4 ) === 1 ) {
			defaultTimer=(__("6.16", i18n))  
			defaultVideoTitle =  (__("5 New Cool Gadgets You Must See on Cartzilla - Cheap Budget", i18n))          
		}

		if ( (i % 4 ) === 2 ) {
			defaultTimer=(__("7.27", i18n)) 
			defaultVideoTitle =  (__("5 Super Useful Gadgets on Cartzilla You Must Have in 2020", i18n))            
		}

		if ( (i % 4 ) === 3 ) {
			defaultTimer=(__("6.20", i18n))
			defaultVideoTitle =  (__("Top 5 New Amazing Gadgets on Cartzilla You Must See", i18n))             
		}

		if ( (i % 4 ) === 0 ) {
			defaultTimer=(__("5.67", i18n))
			defaultVideoTitle =  (__("5 Amazing Construction Inventions and Working Tools Available...", i18n))             
		}

		const bootstrapClass = getBootstrapClasses( undefined, undefined, undefined, lgColumns )

		const blockAdditionalClasses = classnames( [
           
            (i > 3) ? 'd-lg-none' : '',
              
        ])

		return (
			<div className={ `${ bootstrapClass } ${ blockAdditionalClasses } col-6 mb-3` }  key={ i }>
				<a className="d-block text-decoration-0 px-2" href={ link }>
					<div className="video-cover-thumb mb-2">
						{ enableBadge && 
							<RichText
								tagName='span'
								value={ badge || defaultTimer }
								className="badge badge-dark"
								placeholder={ __( 'Badge', i18n ) }
								onChange={ badge => setAttributes( { [ `badge${ i }` ] : badge } ) }
								keepPlaceholderOnFocus
							/>
						}

						<ImageUploadPlaceholder
							imageURL={ imageURL }
							onRemove={ () => {
								setAttributes( {
									[ `imageURL${ i }` ]: '',
								} )
							} }
							onChange={ ( { url } ) => {
								setAttributes( {
									[ `imageURL${ i }` ]: url,
								} )
							} }
							hasRemove={ false }
							render={ <img src={ imageURL } className="w-100" alt={ __( 'Video cover', i18n ) } /> }
						/>
					</div>

					{ enableVideoTitle && 
						<RichText
							tagName='h6'
							value={ videoTitle || defaultVideoTitle }
							className="font-size-sm pt-1"
							placeholder={ __( 'Video Title', i18n ) }
							onChange={ videoTitle => setAttributes( { [ `videoTitle${ i }` ]:videoTitle } ) }
							keepPlaceholderOnFocus
						/>
					}
				</a>
			</div>
		)
	} )
	
	return (
		<div className={ mainClasses }>
   			<div className="border rounded-lg p-3">
             	<div className="row">
             		<div className="col-md-4 mb-3 mb-md-0">
	             		<div className="bg-secondary p-5 text-center">
		             		<ImageUploadPlaceholder
								imageURL={ mediaURL }
								onRemove={ () => {
									setAttributes( {
										mediaURL: '',
									} )
								} }
								onChange={ ( { url } ) => {
									setAttributes( {
										mediaURL: url,
									} )
								} }
								hasRemove={ false }
								render={ <img src={ mediaURL } className="d-block mb-4 mx-auto" width="120" alt={ __( 'YouTube', i18n ) } /> }
							/>
							{ ( enableSubscriberImages || enableSubscriberCount ) && 
								<div className="media justify-content-center align-items-center mb-4">
									{ enableSubscriberImages &&
										<ImageUploadPlaceholder
											imageURL={ mediaURL1 }
											onRemove={ () => {
												setAttributes( {
													mediaURL1: '',
												} )
											} }
											onChange={ ( { url } ) => {
												setAttributes( {
													mediaURL1: url,
												} )
											} }
											hasRemove={ false }
											render={ <img src={ mediaURL1 } className="mr-2" width="126" alt={ __( 'YouTube Subscribers', i18n ) } /> }
										/>
									}
									{ enableSubscriberCount &&
										<RichText
											tagName='span'
											value={ subscriberCount || "250k+" }
											className="font-size-sm"
											onChange={ subscriberCount => setAttributes( { subscriberCount } ) }
											placeholder={ __( 'Subscriber Count' ) }
											keepPlaceholderOnFocus
										/>
									}
								</div>
							}

							<div className="mb-3">{ buttonComp }</div>
							<RichText
								tagName='p'
								value={ text || "*View latest gadgets reviews available for purchase in our store." }
								className="font-size-sm mb-0"
								onChange={ text => setAttributes( { text } ) }
								placeholder={ __( 'Text' ) }
								keepPlaceholderOnFocus
							/>
	             		</div>
             		</div>
             		<div className="col-md-8">
             			{ headerComp }
             			<div className="row no-gutters">
	             			
	             				{ content }
	             			
             			</div>
             		</div>
             	</div>
           	</div>
    	</div>
	)  
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )